import { normalizeSessionId } from '../../shared/leaderboardShared';
import { loadPlayerCountriesByEpicId, normalizeEpicId, PLAYER_COUNTRY_FALLBACK_FLAG_URL } from '../../shared/playerCountryApi';

export async function fetchBackToOgReplayData({ showFlags = false } = {}) {
    const response = await fetch('/api/back-to-og/leaderboard', { cache: 'no-store' });
    if (!response.ok) throw new Error(`Classement indisponible (${response.status}).`);
    const data = await response.json();
    if (!Array.isArray(data.entries)) throw new Error('Réponse du classement invalide.');

    const countries = showFlags
        ? await loadPlayerCountriesByEpicId(data.entries.flatMap((entry) => (entry.players || []).map((player) => player.id)))
        : {};
    const teamDetails = {};
    const leaderboard = data.entries.map((entry) => {
        const members = (entry.players || []).map((player) => ({
            id: player.id, ingame_name: player.name || '',
        }));
        const teamname = members.map((member) => member.ingame_name).filter(Boolean).join(' - ') || entry.key;
        const sessions = (entry.gamesData || []).filter((game) => !game.excluded).map((game) => ({
            id: normalizeSessionId(game.sessionId),
            place: Number(game.placement) || 0,
            kills: Number(game.kills) || 0,
            points: Number(game.totalPoints) || 0,
            start_time: Date.parse(game.timestamp) / 1000 || 0,
        }));
        const place = Number(entry.rank) || 0;
        const points = Number(entry.points) || 0;
        teamDetails[teamname] = { members, sessions, teamData: { place, points } };
        const placed = sessions.filter((session) => session.place > 0);
        return {
            teamId: entry.key, teamname, place, points,
            elims: Number(entry.kills) || 0,
            wins: Number(entry.victories) || 0,
            games: Number(entry.games) || 0,
            avg_place: placed.length ? placed.reduce((sum, session) => sum + session.place, 0) / placed.length : 0,
            alive: false,
            memberData: showFlags ? members.map((member) => ({
                name: member.ingame_name,
                flagUrl: countries[normalizeEpicId(member.id)]?.flagUrl || PLAYER_COUNTRY_FALLBACK_FLAG_URL,
                fallbackFlagUrl: PLAYER_COUNTRY_FALLBACK_FLAG_URL,
            })) : [],
        };
    });
    return { leaderboard, teamDetails };
}
